<template>
  <Dialog
    :visible="visible"
    modal
    :closable="dismissable"
    :close-on-escape="dismissable"
    :dismissable-mask="dismissable"
    :pt="{
      mask: {
        class: 'bg-black/60 backdrop-blur-sm',
      },
      root: {
        class: '!border-0 !bg-transparent !shadow-none',
      },
    }"
    @update:visible="(val: boolean) => { if (!val && dismissable) emit('close'); }"
  >
    <template #container>
      <div
        class="relative flex w-full max-w-[480px] flex-col gap-5 rounded-[20px] bg-white p-7 text-left shadow-2xl sm:p-8"
        role="dialog"
        aria-modal="true"
        aria-labelledby="connect-shop-proceed-title"
      >
        <button
          v-if="dismissable"
          type="button"
          aria-label="Close"
          class="absolute right-5 top-5 rounded-full p-1 text-[--color-neutral-neutral] transition-colors hover:bg-[--color-neutral-neutral-lightest] hover:text-[--color-neutral-black] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--v3-theme-primarycolor]"
          @click="emit('close')"
        >
          <Icon name="times" class="size-4" />
        </button>

        <h3
          id="connect-shop-proceed-title"
          class="v3-regular-medium-line-height-150 text-[--text-primary]"
        >
          Connect Your Etsy Shop to Proceed
        </h3>

        <div class="v3-body-regular-400-line-height-auto flex flex-col gap-4 leading-relaxed text-[--color-neutral-black]">
          <p>
            {{ descriptionText }}
          </p>

          <p>
            We protect your private data. It is never shared with anyone else. It is never sold to anyone. You can learn more by reading our
            <a
              href="https://public.erank.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              class="text-[--v3-button-linkbutton-forestgreen] no-underline transition-opacity hover:opacity-80"
            >privacy policy</a>.
          </p>

          <p>
            You can revoke our access to your private data at any time <a href="https://www.etsy.com/your/shops/me/integrations/installed" class="text-[--v3-button-linkbutton-forestgreen]">here</a>.
          </p>
        </div>

        <div class="pt-2">
          <Button label="Continue" @click="emit('continue')" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { computed } from 'vue';

import Icon from '@/common/components/atoms/Icon';

const props = withDefaults(defineProps<{
  visible: boolean;
  dismissable?: boolean;
  message?: string;
  isPlansPage?: boolean;
}>(), {
  dismissable: false,
  message: '',
  isPlansPage: false,
});

const emit = defineEmits<{
  continue: [];
  close: [];
}>();

const descriptionText = computed(() => {
  if (props.message) {
    return props.message;
  }
  if (props.isPlansPage) {
    return 'Connect your Etsy shop to eRank to purchase a paid plan.';
  }
  return 'Connect your Etsy shop to eRank to gain access to this tool.';
});
</script>
